<template>
  <div>
    <div v-show="!posted">
      <slot name="content"></slot>
      <slot name="form"></slot>
    </div>
    <div v-show="posted" >
      <slot name="result"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'nt-banner-form',
  props: {},
  data() {
    return {
      posted: false,
    }
  },
  created() {
    this.$on('posted', () => {
      this.posted = true
    })
  }
}
</script>

